import { CAMPAIGN_STATUSES } from '@/utils/campaignOptions'
import authService, { USER_ROLES } from '@/api/authService'
import campaignsService from '@/api/campaignsService'

export default {
  name: 'ActivationCkeckDirector',
  mixins: [],
  components: {},
  props: {
    campaign: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      authData: authService.authData,
      isDeleting: false
    }
  },
  computed: {
    status () {
      return this.campaign && this.campaign.status
    },
    isPending () {
      return this.status === CAMPAIGN_STATUSES.CENTRAL_READY
    },
    isAccepted () {
      const {
        CENTRAL_ACCEPTED, AGENCY_CONFIRMED, ACTIVE, FINISHED
      } = CAMPAIGN_STATUSES
      return [CENTRAL_ACCEPTED, AGENCY_CONFIRMED, ACTIVE, FINISHED].indexOf(this.status) !== -1
    },
    isRejected () {
      return this.status === CAMPAIGN_STATUSES.CENTRAL_REJECTED
    },
    isDirector () {
      return this.authData.user.role === USER_ROLES.DIRECTOR
    }
  },
  methods: {
    setDraft () {
      const nextStatus = CAMPAIGN_STATUSES.DRAFT
      campaignsService.updateStatus({
        id: this.campaign.id,
        status: nextStatus
      }).then(() => {
        this.campaign.status = nextStatus
        this.$router.push(`/campaigns/${this.campaign.id}`)
        this.$emit('updateTab', { id: 'info' })
      })
    },
    back () {
      this.$emit('back')
    },
    next () {
      this.$emit('next')
    },
    async remove () {
      if (!this.isDeleting) {
        this.isDeleting = true
        return
      }

      await campaignsService.deleteCampaign({ id: this.campaign.id })
      this.$emit('delete', this.campaign.id)
      this.$router.push('/campaigns')
    }
  }
}
